import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import logoutImg from 'assets/img/icons/spot-illustrations/45.png';
import { useTranslation } from 'react-i18next';
import AppContext from 'context/Context';

const LogoutContent = ({ layout, titleTag: TitleTag }) => {
  const {
    config: { corp }
  } = useContext(AppContext);
  const { t } = useTranslation('auth');
  return (
    <>
      <img
        className="d-block mx-auto mb-4"
        src={logoutImg}
        alt="shield"
        width={100}
      />
      <TitleTag>{t('See you again!')}</TitleTag>
      <p dangerouslySetInnerHTML={{ __html: t('Thanks for using Y4.') }}></p>
      <Button
        as={Link}
        color="primary"
        size="sm"
        className="mt-3"
        to={`/${corp}/authentication/${layout}/login`}
      >
        <FontAwesomeIcon
          icon="chevron-left"
          transform="shrink-4 down-1"
          className="me-1"
        />
        {t('Return to Login')}
      </Button>
    </>
  );
};

LogoutContent.propTypes = {
  layout: PropTypes.string,
  titleTag: PropTypes.string
};

LogoutContent.defaultProps = {
  layout: 'simple',
  titleTag: 'h4'
};

export default LogoutContent;
